module.exports = __webpack_public_path__ + "static/img/gzz5.a7b41e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/gzz5.png
// module id = O27p
// module chunks = 2